<div class="container-fluid">
  <div class="row">
    <div class="col-sm-12">
      <div class="card">
        <div class="card-header d-flex justify-content-between align-items-center">
          <h5>Lista de Instructores</h5>
          <button 
            type="button" 
            class="btn btn-primary" 
            (click)="openAddTeacherModal(addTeacherModal)">
            <i class="fa fa-plus"></i> Agregar Instructor
          </button>
        </div>
        
        <div class="card-body">
          <!-- Información y barra de búsqueda -->
          <div class="row mb-3">
            <div class="col-md-6">
              <div class="input-group">
                <input 
                  type="text" 
                  class="form-control" 
                  placeholder="Buscar por nombre, email o teléfono..." 
                  [(ngModel)]="searchTerm"
                  (input)="filterTeachers()">
                <div class="input-group-append">
                  <span class="input-group-text">
                    <i class="fa fa-search"></i>
                  </span>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="d-flex justify-content-end align-items-center">
                <!-- Control de registros por página -->
                <div class="me-3">
                  <label for="itemsPerPage" class="form-label text-muted me-2 mb-0" style="font-size: 12px;">
                    Registros por página:
                  </label>
                  <select 
                    id="itemsPerPage"
                    class="form-select form-select-sm" 
                    style="width: auto; display: inline-block;"
                    [value]="apiLimit"
                    (change)="changeItemsPerPage(+$any($event.target).value)"
                    [disabled]="isLoading">
                    <option *ngFor="let option of itemsPerPageOptions" [value]="option">
                      {{ option }}
                    </option>
                  </select>
                </div>

                <!-- Control de página -->
                <div class="me-3">
                  <label for="currentPageInput" class="form-label text-muted me-2 mb-0" style="font-size: 12px;">
                    Página:
                  </label>
                  <div class="input-group input-group-sm" style="width: 120px;">
                    <input 
                      type="number" 
                      id="currentPageInput"
                      class="form-control form-control-sm text-center"
                      [value]="currentPage"
                      [min]="1"
                      [max]="getTotalPages()"
                      (keyup.enter)="goToPage(+$any($event.target).value)"
                      (blur)="goToPage(+$any($event.target).value)"
                      [disabled]="isLoading || getTotalPages() <= 1"
                      style="width: 60px;">
                    <span class="input-group-text bg-light" style="font-size: 11px;">
                      de {{ getTotalPages() }}
                    </span>
                  </div>
                </div>

                <button 
                  class="btn btn-outline-primary btn-sm me-3"
                  (click)="reloadTable()"
                  [disabled]="isLoading"
                  title="Recargar tabla">
                  <i class="fa fa-refresh" [class.fa-spin]="isLoading"></i>
                  {{ isLoading ? 'Cargando...' : 'Recargar' }}
                </button>
                <span class="text-muted me-3" *ngIf="!isLoading">
                  <i class="fa fa-users me-1"></i>
                  Total: {{ totalCount }} instructor{{ totalCount !== 1 ? 'es' : '' }}
                </span>
                <span class="text-muted" *ngIf="searchTerm && !isLoading">
                  | Mostrando: {{ filteredTeachers.length }}
                </span>
              </div>
            </div>
          </div>

          <!-- Loading Spinner -->
          <div *ngIf="isLoading" class="text-center py-4">
            <div class="spinner-border text-primary" role="status">
              <span class="sr-only">Cargando...</span>
            </div>
            <p class="mt-2">Cargando instructores...</p>
          </div>

          <!-- Tabla de instructores -->
          <div *ngIf="!isLoading" class="table-responsive">
            <table class="table table-striped table-bordered">
              <thead class="thead-light">
                <tr>
                  <th scope="col">#</th>
                  <th scope="col" class="sortable" (click)="sortBy('name')">
                    Nombre
                    <i class="fa ms-1" [ngClass]="getSortIcon('name')"></i>
                  </th>
                  <th scope="col" class="sortable" (click)="sortBy('email')">
                    Email
                    <i class="fa ms-1" [ngClass]="getSortIcon('email')"></i>
                  </th>
                  <th scope="col" class="sortable" (click)="sortBy('phoneNumber')">
                    Teléfono
                    <i class="fa ms-1" [ngClass]="getSortIcon('phoneNumber')"></i>
                  </th>
                  <th scope="col" class="sortable" (click)="sortBy('active')">
                    Estado
                    <i class="fa ms-1" [ngClass]="getSortIcon('active')"></i>
                  </th>
                  <th scope="col" class="sortable" (click)="sortBy('created_at')">
                    Fecha de Registro
                    <i class="fa ms-1" [ngClass]="getSortIcon('created_at')"></i>
                  </th>
                  <th scope="col" class="text-center">Acciones</th>
                </tr>
              </thead>
              <tbody>
                <!-- Mensaje cuando no hay instructores -->
                <tr *ngIf="paginatedTeachers.length === 0">
                  <td colspan="7" class="text-center py-4">
                    <div class="empty-state">
                      <i class="fa fa-users fa-3x text-muted mb-3"></i>
                      <h5 class="text-muted">No hay instructores registrados</h5>
                      <p class="text-muted">
                        {{ searchTerm ? 'No se encontraron instructores con ese criterio de búsqueda.' : 'Comienza agregando tu primer instructor.' }}
                      </p>
                      <button 
                        *ngIf="!searchTerm"
                        type="button" 
                        class="btn btn-primary"
                        (click)="openAddTeacherModal(addTeacherModal)">
                        <i class="fa fa-plus"></i> Agregar Primer Instructor
                      </button>
                    </div>
                  </td>
                </tr>

                <!-- Lista de instructores paginados -->
                <tr *ngFor="let teacher of paginatedTeachers; let i = index" [hidden]="teacher.active === false">
                  <th scope="row">{{ ((currentPage - 1) * itemsPerPage) + i + 1 }}</th>
                  <td>
                    <div class="d-flex align-items-center">
                      <div class="avatar-initials me-2">
                        {{ (teacher.firstName?.charAt(0) || '') + (teacher.lastName?.charAt(0) || '') || 'I' }}
                      </div>
                      {{ teacher.firstName }} {{ teacher.lastName }}
                    </div>
                  </td>
                  <td>{{ teacher.email }}</td>
                  <td>{{ formatPhoneNumber(teacher.phoneNumber) }}</td>
                  <td>
                    <span 
                      class="badge"
                      [class.badge-success]="teacher.active"
                      [class.badge-secondary]="!teacher.active">
                      {{ teacher.active ? 'Activo' : 'Inactivo' }}
                    </span>
                  </td>
                  <td>{{ teacher.created_at | date:'dd/MM/yyyy' }}</td>
                  <td class="text-center">
                    <div class="btn-group" role="group">
                      <button 
                        type="button" 
                        class="btn btn-sm btn-outline-primary"
                        title="Ver detalles">
                        <i class="fa fa-eye"></i>
                      </button>
                      <button 
                        type="button" 
                        class="btn btn-sm btn-outline-secondary"
                        title="Editar">
                        <i class="fa fa-edit"></i>
                      </button>
                      <button 
                        type="button" 
                        class="btn btn-sm btn-outline-danger"
                        title="Eliminar"
                        (click)="deleteTeacher(teacher.id)">
                        <i class="fa fa-trash"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Paginación -->
          <div *ngIf="!isLoading && filteredTeachers.length > 0" class="d-flex justify-content-between align-items-center mt-3">
            <div>
              <span class="text-muted">
                Mostrando {{ ((currentPage - 1) * apiLimit) + 1 }} - 
                {{ Math.min(currentPage * apiLimit, totalCount) }} 
                de {{ totalCount }} registros (Página {{ currentPage }} de {{ getTotalPages() }})
              </span>
            </div>
            
            <nav aria-label="Paginación de instructores" *ngIf="getTotalPages() > 1">
              <ul class="pagination pagination-sm mb-0">
                <!-- Botón Primera página -->
                <li class="page-item" [class.disabled]="currentPage === 1">
                  <button 
                    class="page-link" 
                    (click)="goToFirstPage()"
                    [disabled]="currentPage === 1"
                    title="Primera página">
                    <i class="fa fa-angle-double-left"></i>
                  </button>
                </li>
                
                <!-- Botón Anterior -->
                <li class="page-item" [class.disabled]="currentPage === 1">
                  <button 
                    class="page-link" 
                    (click)="changePage(currentPage - 1)"
                    [disabled]="currentPage === 1"
                    title="Página anterior">
                    <i class="fa fa-angle-left"></i>
                  </button>
                </li>
                
                <!-- Primera página (si no está visible) -->
                <li class="page-item" *ngIf="getPageNumbers()[0] > 1">
                  <button class="page-link" (click)="changePage(1)">1</button>
                </li>
                <li class="page-item disabled" *ngIf="getPageNumbers()[0] > 2">
                  <span class="page-link">...</span>
                </li>
                
                <!-- Páginas visibles -->
                <li 
                  class="page-item" 
                  *ngFor="let page of getPageNumbers()"
                  [class.active]="page === currentPage">
                  <button class="page-link" (click)="changePage(page)">{{ page }}</button>
                </li>
                
                <!-- Última página (si no está visible) -->
                <li class="page-item disabled" *ngIf="getPageNumbers()[getPageNumbers().length - 1] < getTotalPages() - 1">
                  <span class="page-link">...</span>
                </li>
                <li class="page-item" *ngIf="getPageNumbers()[getPageNumbers().length - 1] < getTotalPages()">
                  <button class="page-link" (click)="changePage(getTotalPages())">{{ getTotalPages() }}</button>
                </li>
                
                <!-- Botón Siguiente -->
                <li class="page-item" [class.disabled]="currentPage === getTotalPages()">
                  <button 
                    class="page-link" 
                    (click)="changePage(currentPage + 1)"
                    [disabled]="currentPage === getTotalPages()"
                    title="Página siguiente">
                    <i class="fa fa-angle-right"></i>
                  </button>
                </li>
                
                <!-- Botón Última página -->
                <li class="page-item" [class.disabled]="currentPage === getTotalPages()">
                  <button 
                    class="page-link" 
                    (click)="goToLastPage()"
                    [disabled]="currentPage === getTotalPages()"
                    title="Última página">
                    <i class="fa fa-angle-double-right"></i>
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal para agregar instructor -->
<ng-template #addTeacherModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Agregar Nuevo Instructor</h4>
    <button 
      type="button" 
      class="btn-close" 
      aria-label="Close" 
      (click)="closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  
  <form [formGroup]="teacherForm" (ngSubmit)="onSubmit()">
    <div class="modal-body">
      <!-- Campo Nombre -->
      <div class="mb-3">
        <label for="firstName" class="form-label">
          Nombre <span class="text-danger">*</span>
        </label>
        <input 
          type="text" 
          class="form-control"
          id="firstName"
          formControlName="firstName"
          placeholder="Ingrese el nombre"
          [class.is-invalid]="firstName?.invalid && firstName?.touched">
        
        <div *ngIf="firstName?.invalid && firstName?.touched" class="invalid-feedback">
          <div *ngIf="firstName?.errors?.['required']">El nombre es obligatorio.</div>
          <div *ngIf="firstName?.errors?.['minlength']">El nombre debe tener al menos 2 caracteres.</div>
          <div *ngIf="firstName?.errors?.['maxlength']">El nombre no puede exceder 50 caracteres.</div>
        </div>
      </div>

      <!-- Campo Apellido -->
      <div class="mb-3">
        <label for="lastName" class="form-label">
          Apellido <span class="text-danger">*</span>
        </label>
        <input 
          type="text" 
          class="form-control"
          id="lastName"
          formControlName="lastName"
          placeholder="Ingrese el apellido"
          [class.is-invalid]="lastName?.invalid && lastName?.touched">
        
        <div *ngIf="lastName?.invalid && lastName?.touched" class="invalid-feedback">
          <div *ngIf="lastName?.errors?.['required']">El apellido es obligatorio.</div>
          <div *ngIf="lastName?.errors?.['minlength']">El apellido debe tener al menos 2 caracteres.</div>
          <div *ngIf="lastName?.errors?.['maxlength']">El apellido no puede exceder 50 caracteres.</div>
        </div>
      </div>

      <!-- Campo Email -->
      <div class="mb-3">
        <label for="email" class="form-label">
          Correo electrónico <span class="text-danger">*</span>
        </label>
        <input 
          type="email" 
          class="form-control"
          id="email"
          formControlName="email"
          placeholder="instructor@ejemplo.com"
          [class.is-invalid]="email?.invalid && email?.touched">
        
        <div *ngIf="email?.invalid && email?.touched" class="invalid-feedback">
          <div *ngIf="email?.errors?.['required']">El correo electrónico es obligatorio.</div>
          <div *ngIf="email?.errors?.['email']">Ingrese un correo electrónico válido.</div>
        </div>
      </div>

      <!-- Campo Teléfono -->
      <div class="mb-3">
        <label for="phoneNumber" class="form-label">
          Número de teléfono <span class="text-danger">*</span>
        </label>
        <input 
          type="tel" 
          class="form-control"
          id="phoneNumber"
          formControlName="phoneNumber"
          placeholder="1234567890"
          maxlength="10"
          [class.is-invalid]="phoneNumber?.invalid && phoneNumber?.touched">
        
        <div *ngIf="phoneNumber?.invalid && phoneNumber?.touched" class="invalid-feedback">
          <div *ngIf="phoneNumber?.errors?.['required']">El número de teléfono es obligatorio.</div>
          <div *ngIf="phoneNumber?.errors?.['pattern']">Ingrese un número de teléfono válido de 10 dígitos.</div>
        </div>
        <div class="form-text">
          Ingrese 10 dígitos sin espacios ni guiones.
        </div>
      </div>
    </div>
    
    <div class="modal-footer">
      <button 
        type="button" 
        class="btn btn-secondary" 
        (click)="closeModal()"
        [disabled]="isSubmitting">
        Cancelar
      </button>
      <button 
        type="submit" 
        class="btn btn-primary"
        [disabled]="teacherForm.invalid || isSubmitting">
        <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm me-2" role="status"></span>
        {{ isSubmitting ? 'Registrando...' : 'Registrar Instructor' }}
      </button>
    </div>
  </form>
</ng-template>
